import React from 'react';
import useNetworkStatus from '_utils/use-network-status';

// styling
import { Spacing, Colors } from '_styles';

// icons 
import { FiWifiOff } from "react-icons/fi";

const NetworkStatusBanner = () => {
  
  const isOnline = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div style={styles.banner}>
      <FiWifiOff /> No internet connection. Some features may not work.
    </div>
  );
};

const styles = {
  banner: {
    backgroundColor: Colors.PRM_LIGHT_BLUE,
    color: 'white',
    padding: Spacing.SCALE_10,
    textAlign: 'center',
    fontWeight: 'bold',
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 1000,

    // Make icon in line with text
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: Spacing.SCALE_8, 
  },
};

export default NetworkStatusBanner;
